import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import n from "./index.es5615.js";
import { ColorIndicator as u } from "./index.es32.js";
import { SelectText as C } from "./index.es509.js";
import { Icon as b } from "./index.es157.js";
import { UtilityChevronIcon as v } from "./index.es439.js";
import { onKeyDownEnterAndSpace as E } from "./index.es526.js";
const S = "base-compact-select", _ = h(
  ({
    shouldSpaceBetween: l,
    value: c,
    entityColor: a,
    disabled: m,
    colorIndicator: i,
    colorIndicatorProps: e,
    testId: d = S,
    isLocked: p,
    isOpen: y,
    ...s
  }, f) => /* @__PURE__ */ o(
    "div",
    {
      "data-testid": d,
      className: n.trigger,
      style: { justifyContent: l ? "space-between" : "unset" },
      tabIndex: 0,
      "data-type": "compact-select",
      "aria-disabled": m,
      role: "button",
      onKeyDown: (r) => {
        E(r, s.onClick);
      },
      ref: f,
      ...s,
      children: [
        (!!a || i) && /* @__PURE__ */ t("span", { className: n.entity, children: /* @__PURE__ */ t(
          u,
          {
            color: i,
            entityColor: a,
            thickness: "regular",
            disabled: m,
            testId: (e == null ? void 0 : e.testId) || `color-${(e == null ? void 0 : e.entityColor) || a}`,
            ...e
          }
        ) }),
        /* @__PURE__ */ t(
          C,
          {
            variant: "semi-bold",
            element: "p",
            color: m ? "disabled" : "primary",
            children: c
          }
        ),
        p ? /* @__PURE__ */ t("div", { className: n.icon, "data-type": "lock", children: /* @__PURE__ */ t(b, { size: 16, type: "Lock", testId: "lock-icon" }) }) : /* @__PURE__ */ t("div", { className: n.icon, "data-type": "chevron", children: /* @__PURE__ */ t(
          v,
          {
            direction: y ? "up" : "down",
            outline: m ? "disabled" : "default-gray",
            type: "bold"
          }
        ) })
      ]
    }
  )
);
export {
  _ as BaseCompactSelect,
  S as COMPACT_BASE_SELECT_DEFAULT_TESTID
};
//# sourceMappingURL=index.es855.js.map
